// Entry form route for a specific collection
import { createFileRoute, useNavigate, useParams } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { useCollection } from '@/features/datahub/api/use-collection';
import { CollectionEntryForm } from '@/features/datahub/collections/CollectionEntryForm';

export const Route = createFileRoute(
  '/_authenticated/datahub/collections/$collectionId/entry'
)({
  component: EntryPage,
});

function EntryPage() {
  const { collectionId } = useParams({ strict: false });
  const navigate = useNavigate();

  const { data: collection, isLoading } = useCollection({ collectionId: collectionId ?? '' });

  if (isLoading) {
    return (
      <div className="space-y-6 p-6">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (!collection) return null;

  return (
    <div className="space-y-6 p-6">
      <Button
        data-testid="back-to-collection-btn"
        variant="ghost"
        size="sm"
        onClick={() => void navigate({ to: `/datahub/collections/${collectionId ?? ''}` })}
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        Back to {collection.name}
      </Button>
      <h1 className="text-2xl font-bold tracking-tight">
        Enter Data: {collection.name}
      </h1>
      <CollectionEntryForm
        collectionId={collection.id}
        items={collection.items}
        onSuccess={() => void navigate({ to: `/datahub/collections/${collectionId ?? ''}` })}
      />
    </div>
  );
}
